import styled, { keyframes } from 'styled-components';
import { Colors } from '../../colors';
const getSize = (size) => ({ small: 15, medium: 18, large: 32 })[size];
const getColor = ({ $appearance, theme, }) => {
    var _a, _b, _c, _d, _e, _f;
    if ($appearance === 'primary' && ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorOnPrimary)) {
        return (_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles.colorOnPrimary;
    }
    if ($appearance === 'secondary' && ((_e = (_d = theme.automated) === null || _d === void 0 ? void 0 : _d.styles) === null || _e === void 0 ? void 0 : _e.colorOnBackground)) {
        return (_f = theme.automated) === null || _f === void 0 ? void 0 : _f.styles.colorOnBackground;
    }
    if ($appearance === 'primary') {
        return Colors.GS0;
    }
    if ($appearance === 'secondary') {
        return Colors.GS1000;
    }
};
const wrapperAnimation = keyframes `
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
`;
const circleAnimation = keyframes `
  0%,
  25% {
    stroke-dashoffset: 270;
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: 270;
    transform: rotate(360deg);
  }
`;
export const Wrapper = styled.svg `
  width: ${({ $size }) => getSize($size)}px;
  animation: 2s linear infinite ${wrapperAnimation};
  animation-delay: -1.5s;
`;
export const Circle = styled.circle `
  animation: 1.4s ease-in-out infinite both ${circleAnimation};
  animation-delay: -1.05s;
  display: block;
  fill: transparent;
  stroke: ${getColor};
  stroke-dasharray: 283;
  stroke-dashoffset: 75;
  stroke-width: 10px;
  transform-origin: 50% 50%;
`;
//# sourceMappingURL=styled.js.map